type TokenPayload = {
  sub: string;
  name: string;
  given_name: string;
  family_name: string;
  email: string;
  email_verified: boolean;
  profile_photo: string;
  photos?: string[] | string;
  [key: string]: any;
};

const getTokenPayload = (): TokenPayload | null => {
  const token = localStorage.getItem('accessToken');
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

export const getUserId = (): string | null => {
  return getTokenPayload()?.sub ?? null;
};

export const getProfilePhoto = (): string | null => {
  return getTokenPayload()?.profile_photo ?? null;
};

export const getFirstName = (): string | null => {
  return getTokenPayload()?.given_name ?? null;
};

export const getFullName = (): string | null => {
  return getTokenPayload()?.name ?? null;
};

export const getLastName = (): string | null => {
  return getTokenPayload()?.family_name ?? null;
};

export const getEmail = (): string | null => {
  return getTokenPayload()?.email ?? null;
};

export const isEmailVerified = (): TokenPayload | null => {
  return getTokenPayload();
};

export const getPhotosFromToken = (): string[] => {
  const photos = getTokenPayload()?.photos;
  if (!photos) return [];
  if (Array.isArray(photos)) return photos;
  return [photos]; // Tek bir fotoğraf varsa diziye çevir
};